import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class FinishToInRevision extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.FINISH_TO_IN_REVISION]);
  }
}

export default FinishToInRevision;
